<template>
    <div class="main">
        <div v-if="!shouldHideChrome" class="left"
             :class="{ 'collapsed': !isMenuExpanded, 'overlap': isOverlapping }"
             v-click-outside="handleClickOutside">
            <header v-if="!shouldHideChrome" :class="{ collapsed: !isMenuExpanded || shouldHideChrome }">
                <img v-if="isMenuExpanded && !shouldHideChrome" src="@/assets/zone_soft_logo.svg" height="40px" alt="Logo">
                <ZSIcon v-if="isMenuExpanded && !shouldHideChrome" @click.stop="toggleMenu" @keydown.enter="toggleMenu"
                    @keydown.space="toggleMenu" tabindex="0" class="toggle-icon" :rotation="isMenuExpanded ? '0' : '180'"
                    color="#D35400" icon="backBurger" v-tooltip:right="$t(isMenuExpanded ? 'general.collapse_menu' : 'general.expand_menu')"
                    role="button" aria-label="Toggle menu visibility"></ZSIcon>
            </header>
            <div :class="{'partner-info':true,'collapsed': !isMenuExpanded}">
                <div class="avatar">{{ getInitials(user.login) }}</div>
                <div class="info">
                    <div class="name">Login: {{ user.login }}</div>
                    <div class="partner-id">ID Parceiro: {{ user.partner_id }}</div>
                </div>
                <div v-can="'partner.view'" class="action">
                    <ZSButton v-tooltip:right="t('partner_data.title')" @click="editPartnerData" icon="gear" class="text" icon-color="white"></ZSButton>
                </div>
            </div>
            <nav>
                <ZSNav @linkClicked="onLinkClicked" @openMoodleWizard="openMoodleWizard" :collapsed="!isMenuExpanded || isLoginForm" />
            </nav>
            <div :class="{ 'sidenav-footer': true, 'collapsed': !isMenuExpanded }">
                <span>v{{ appVersion }}</span>
            </div>
        </div>
        <div class="center" :class="{ 'expanded': !isMenuExpanded || shouldHideChrome }">
            <header v-if="!shouldHideChrome">
                <div class="left-center-header">
                    <ZSIcon v-if="!isMenuExpanded" @click.stop="toggleMenu" @keydown.enter="toggleMenu"
                        @keydown.space="toggleMenu" tabindex="0" class="menu-expand-icon" icon="backBurger"
                        color="#D35400" v-tooltip:right="$t('general.expand_menu')" role="button"
                        aria-label="Expand navigation menu"></ZSIcon>
                    <img :class="{ 'expanded': !isMenuExpanded || isLoginForm }" class="zslic_logo"
                        src="@/assets/zslic_logo.svg" height="40px" alt="Logo">
                </div>
                <div class="license-name hide lg-show">{{ user.partner_name }}</div>
                <div class="user-actions">
                    <!-- <ZSButton  @click="editPartnerData" class="text" color="orange" icon="UserEdit"><span class="hide md-show">{{ $t('partner_data.title') }}</span></ZSButton> -->

                        <ZSButton  class="text" color="orange" @click="logout" icon="PowerOff"><span class="hide md-show">{{ $t('general.exit') }}</span></ZSButton>
                    <!-- Language Dropdown -->
                    <ZSDropdown trigger-text="" align="right" ref="languageDropdown">
                        <template #trigger="{ toggle }">
                            <div class="language-trigger" @click="toggle">
                                <span v-if="locale == 'pt'"><img alt="Português" class="flag" src="@/assets/portugal.png" /></span>
                                <span v-if="locale == 'es'"><img alt="Español" class="flag" src="@/assets/spain.png" /></span>
                                <span v-if="locale == 'en'"><img alt="English" class="flag" src="@/assets/united-kingdom.png" /></span>
                                <span v-if="locale == 'fr'"><img alt="Francais" class="flag" src="@/assets/france-flag-icon.webp" /></span>
                                <img src="@/assets/ChevronDown.svg" alt="Dropdown" class="chevron-icon">
                            </div>
                        </template>

                        <div class="language-menu">
                            <div class="menu-item lang-item" @click="changeLanguage('pt')">
                                <img alt="Português" class="flag" src="@/assets/portugal.png" />
                                <span>Português</span>
                            </div>
                            <div class="menu-item lang-item" @click="changeLanguage('es')">
                                <img alt="Español" class="flag" src="@/assets/spain.png" />
                                <span>Español</span>
                            </div>
                            <div class="menu-item lang-item" @click="changeLanguage('en')">
                                <img alt="English" class="flag" src="@/assets/united-kingdom.png" />
                                <span>English</span>
                            </div>
                            <div class="menu-item lang-item" @click="changeLanguage('fr')">
                                <img alt="Francais" class="flag" src="@/assets/france-flag-icon.webp" />
                                <span>Francais</span>
                            </div>
                        </div>
                    </ZSDropdown>

                </div>
            </header>

            <ZSDialog width="min(1280px, 96vw)" :confirmLabel="$t('general.save')" :cancelLabel="$t('general.cancel')" :title="$t('partner_data.title')" ref="dialog" :confirmCallback="savePartnerData"  >
                <div v-if="isProfileDialogLoading" class="profile-dialog-loading">
                    <Loader />
                    <div class="profile-dialog-loading-text">{{ t('loading') }}</div>
                </div>
                <ZSTabView v-else class="profile-dialog-tabs">
                    <ZSTab v-if="userStore.hasPermission('partner.general.view')" :title="$t('partner_data.general')">
                        <div style="max-width: min(100vw, 1000px)" class="form">
                            <div class="row">
                                <div class="col-12 col-md-8">
                                    <ZSInput :label="$t('partner_data.name')" disabled v-model="partner.nome">
                                    </ZSInput>
                                </div>
                                <div class="col-12 col-md-4">
                                    <ZSInput :label="$t('partner_data.nif')" disabled v-model="partner.contribuinte">
                                    </ZSInput>
                                </div>
                            </div>
                            <div class="row align-end">
                                <div class="col-12">
                                    <ZSInput :label="$t('partner_data.address')" v-model="partner.morada">
                                    </ZSInput>
                                </div>
                                <div class="col-12 col-md-4">
                                    <ZSInput :label="$t('partner_data.zip')" v-model="partner.cp1"></ZSInput>
                                </div>
                                <div class="col-12 col-md-2">
                                    <ZSInput label="" v-model="partner.cp2"></ZSInput>
                                </div>
                                <div class="col-12 col-md-6">
                                    <ZSInput :label="$t('partner_data.local')" v-model="partner.cp3"></ZSInput>
                                </div>
                            </div>
                            <div class="row align-end">
                                <div class="col-12">
                                    <ZSInput :label="$t('partner_data.contact')" v-model="partner.contacto">
                                    </ZSInput>
                                </div>
                                <div class="col-12 col-md-6">
                                    <ZSInput :label="$t('partner_data.phone')" v-model="partner.telefone">
                                    </ZSInput>
                                </div>
                                <div class="col-12 col-md-6">
                                    <ZSInput :label="$t('partner_data.mobile')" v-model="partner.movel"></ZSInput>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 col-md-6">
                                    <ZSInput :label="$t('partner_data.email')" v-model="partner.email"></ZSInput>
                                </div>
                                <div class="col-6">
                                    <ZSInput :label="$t('partner_data.www')" v-model="partner.web"></ZSInput>
                                </div>
                            </div>
                        </div>
                    </ZSTab>
                    <ZSTab :title="$t('system.rbac.permissions_title')" v-if="canAccessProfilePermissions">
                        <PermissionsTab />
                    </ZSTab>
                    <ZSTab v-if="userStore.hasPermission('partner.users.view')" :title="$t('partner_users.title')">
                        <UsersTab />
                    </ZSTab>
                    <ZSTab v-if="userStore.hasPermission('partner.vivawallet.view')"  title="Viva">
                        <VivaWalletTab :disablewebhook="disablewebhook" @update:vivawallet="updatevivawallet" />
                    </ZSTab>
                </ZSTabView>
            </ZSDialog>

            <MoodleUserWizard ref="moodleWizard" />

            <RouterView />
        </div>
    </div>
</template>

<script setup>
import { RouterView } from 'vue-router'
import PermissionsTab from '@/views/Partner/PermissionsTab.vue'
import VivaWalletTab from '@/views/Partner/VivaWalletTab.vue'
import UsersTab from '@/views/Partner/UsersTab.vue'
import MoodleUserWizard from '@/components/moodle/MoodleUserWizard.vue'
import { defaultVIVAWALLET, defaultPartnerInfo } from "@/use/defaultvalues.js";
import { useMediaQuery } from "@/use/media_query";

import { ref, onMounted, watch, onBeforeUnmount, computed, nextTick } from 'vue'


import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()



const props = defineProps({
    overlap: {
        type: Boolean,
        default: false
    },
    collapseOnOutsideClick: {
        type: Boolean,
        default: true
    }
})

const isLoginForm = computed(() => route.name === 'login' || route.path === '/login')
const isMaintenance = computed(() => route.name === 'maintenance' || route.path === '/maintenance')
const isCloudkeeperActivated = computed(() => route.name === 'cloudkeeper_activated' || route.path === '/cloudkeeper-activated')
const shouldHideChrome = computed(() => isLoginForm.value || isMaintenance.value || isCloudkeeperActivated.value)

import { useMiscStore } from "@/stores/misc";
import { useUserStore } from "@/stores/user";
import { useAppVersion } from "@/use/appVersion";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import { useZSToast } from "@/components/zs-components/toast/useToast";
import ZSButton from '../ZSButton.vue';

const miscStore = useMiscStore();
const userStore = useUserStore();
const { user, partner, partnerInfo } = storeToRefs(userStore);
const { t, locale } = useI18n();
const { add: addToast } = useZSToast();
const { appVersion } = useAppVersion();
const toOverlap = ref(props.overlap)
const isProfileDialogLoading = ref(false);
const canAccessProfilePermissions = computed(() => {
    const val =  user.value?.master === true || (userStore.rbacEnabled && userStore.permissions.includes('partner.permissions.view'));
    return val;
});

// Password change
const passwordForm = ref({
  oldPassword: '',
  newPassword: '',
  confirmPassword: ''
});

const canChangePassword = computed(() => {
  return passwordForm.value.oldPassword &&
    passwordForm.value.newPassword &&
    passwordForm.value.confirmPassword &&
    passwordForm.value.newPassword === passwordForm.value.confirmPassword;
});

const handleChangePassword = async () => {
  if (!passwordForm.value.oldPassword || !passwordForm.value.newPassword || !passwordForm.value.confirmPassword) {
    addToast({ position: 'tr', summary: t('partner_users.change_password'), detail: t('partner_users.password_fields_required'), type: 'warn', life: 4000 });
    return;
  }
  if (passwordForm.value.newPassword !== passwordForm.value.confirmPassword) {
    addToast({ position: 'tr', summary: t('partner_users.change_password'), detail: t('partner_users.password_mismatch'), type: 'warn', life: 4000 });
    return;
  }
  try {
    await userStore.changePassword({
      login: user.value.login,
      password: passwordForm.value.oldPassword,
      new_password: passwordForm.value.newPassword,
    });
    addToast({ position: 'tr', summary: t('partner_users.change_password'), detail: t('partner_users.password_changed'), type: 'success', life: 4000 });
    passwordForm.value = { oldPassword: '', newPassword: '', confirmPassword: '' };
  } catch (e) {
    // Error handled by axios interceptor
  }
};

const isOverlapping = computed(()=> {
    return toOverlap.value || isSmall.value
})

const getInitials = (name) => {
    if (!name) return '';
    const parts = name.trim().split(' ').filter(Boolean);
    if (parts.length === 0) return '';
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};


const { xs,sm, md } = useMediaQuery();

const isSmall = computed(() => {
  return xs.value || sm.value || md.value;
});

const emit = defineEmits(["close", "logout"]);


const isMenuExpanded = ref(true)
const isReady = ref(false);

const dialog = ref(null)
const languageDropdown = ref(null)
const moodleWizard = ref(null)

const openMoodleWizard = () => {
    moodleWizard.value?.open()
}

const chipData = ref("123,456,789")
const chips = ref(["123", "456", "789"])

// Clean up event listener on component unmount
onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeydown)
})

// Listen for keyboard shortcut (Alt+M)
const handleKeydown = (event) => {
    if (event.altKey && event.key === 'm') {
        toggleMenu()
    }
}

const handleClickOutside = () => {
    if (isReady.value && props.collapseOnOutsideClick && isOverlapping.value && isMenuExpanded.value) {
        isMenuExpanded.value = false;
    }
};

// Save menu state to localStorage when it changes
watch(isMenuExpanded, (newValue) => {
    localStorage.setItem('menuExpanded', newValue)
})

const toggleMenu = () => {
    isMenuExpanded.value = !isMenuExpanded.value
}

const loadProfileDialogData = async () => {
    isProfileDialogLoading.value = true;

    try {
        await Promise.allSettled([
            userStore.getPartner(),
            userStore.getPartnerInfo(),
        ]);
    } finally {
        isProfileDialogLoading.value = false;
    }
}

const editPartnerData = () => {
    dialog.value.show();
    loadProfileDialogData();
}


const logout = async () => {
    languageDropdown.value?.closeDropdown?.();
    await router.replace("/login");
    await nextTick();
    await userStore.logout();
};

const changeLanguage = (lang) => {
    locale.value = lang;
    localStorage.setItem("lang", lang);
    languageDropdown.value.closeDropdown();
};

const disablewebhook = ref(true);
let vivawalletdata = [];

const updatevivawallet = (vivawallet) => {
  vivawalletdata = [];
  vivawalletdata = defaultVIVAWALLET.map((wallet) => {
    const ref = vivawallet[wallet.key];
    return {
      ...defaultPartnerInfo,
      revendedor: partner.value.codigo,
      chave: wallet.key,
      valor: ref ? ref.key : null,
    };
  });
};

watch(
  () => partnerInfo.value,
  () => {
    if (partnerInfo.value.length > 0) {
      vivawalletdata = [];

      partnerInfo.value.forEach((info) => {
        const wallet = defaultVIVAWALLET.find((w) => w.key === info.chave);
        if (wallet) {
          vivawalletdata.push({
            ...defaultPartnerInfo,
            revendedor: partner.value.codigo,
            chave: wallet.key,
            valor: info.valor,
          });
        }
      });
    }
  }
);

const savePartnerData = async () => {
  const resp = await userStore.savePartner(vivawalletdata);
  if (resp.status === "ok") {
    addToast({
      position: "tr",
      type: "success",
      summary: t("partner_data.success"),
      detail: "",
      life: 6000,
    });
    disablewebhook.value = false;
  }
};

const onLinkClicked = () => {
   if(isOverlapping.value && isMenuExpanded.value)  isMenuExpanded.value = false;
}

// Load saved menu state from localStorage on component mount
onMounted(() => {
    const savedState = localStorage.getItem('menuExpanded')
    if (savedState !== null) {
        isMenuExpanded.value = savedState === 'true'
    }

    // Add keyboard shortcut listener
    window.addEventListener('keydown', handleKeydown)
      miscStore.getAllSoftwareList();

    nextTick(() => {
        isReady.value = true;
    });
})

</script>

<style scoped>
.main {
    display: flex;
    flex-direction: row;
    height: 100vh;
    background-color: #f5f5f5;
    position: relative;
    overflow: hidden;



    .left {
        display: flex;
        flex-direction: column;
        /* background-color: red; */
        background-color: #1e1e2d;
        width: clamp(150px, 300px, 100vw);
        min-width: clamp(150px, 300px, 100vw);
        overflow-y: auto;
        color: white;
        transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275),
            width 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275),
            min-width 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275),
            box-shadow 0.3s ease;
        position: relative;
        z-index: 10;
        box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);

        &.collapsed {
            transform: translateX(-100%);
            width: 0;
            min-width: 0;
            box-shadow: none;
        }

        &.overlap {
            position: absolute;
            height: 100%;
            z-index: 1000;
        }

        &.overlap.collapsed {
            /* When overlapping, we still want the menu to have width for the animation */
            width: 300px;
            min-width: 300px;
        }

        header {
            background-color: #1e1e2d;
            justify-content: space-between;
        }

        .partner-info{
            display: flex;
            align-items: center;
            border-bottom: 1px solid #626262;
            .avatar{
                width: 50px;
                height: 50px;
                background-color: var(--color-orange);
                border-radius: 5px;
                margin:1.3rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 1.8em;

            }
            .info{
                flex:1;
            }


            &.collapsed{
                display: none;
            }

        }

        .sidenav-footer {
            margin-top: auto;
            padding: 10px 1.3rem;
            display: flex;
            justify-content: center;
            border-top: 1px solid #626262;
            font-size: 11px;
            color: rgba(255, 255, 255, 0.45);

            &.collapsed {
                display: none;
            }
        }
    }

    .center {
        display: flex;
        flex-direction: column;
        background-color: white;
        width: 100%;
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;

        &.expanded {
            width: 100%;

            &::after {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 4px;
                height: 100%;
                background-color: rgba(211, 84, 0, 0.1);
                animation: highlight-border 1s ease-out forwards;
            }

            @keyframes highlight-border {
                0% {
                    opacity: 1;
                }

                100% {
                    opacity: 0;
                }
            }
        }

        header {
            background-color: white;
            border-left: none;
            display: flex;
            align-items: center;
            justify-content: space-between;
             border-bottom: 1px solid #bebebe;
            padding: 1em;
            gap: 15px;

            .header-title {
                font-family: "Satoshi-Bold", sans-serif;
                font-size: 18px;
                color: #333;
            }

            .left-center-header {
                display: flex;
            }

            .license-name {
                font-weight: 700;
                font-size: 1.3em;
            }
        }
    }


    header {
        height: 80px;
        background-color: #f8f8f8;
        width: 100%;
        padding: 1em;
        border-bottom: 1px solid #626262;
        display: flex;
        align-items: center;

        &.collapsed {
            padding: 0;
        }
    }

    .toggle-icon {
        cursor: pointer;
        transition: transform 0.3s ease, background-color 0.2s ease;
        padding: 5px;
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 0.05);

        &:hover {
            background-color: rgba(255, 255, 255, 0.2);
            transform: scale(1.1);
        }

        &:active {
            transform: scale(0.95);
        }

        &:focus {
            outline: 2px solid rgba(255, 255, 255, 0.3);
            outline-offset: 2px;
        }
    }

    .menu-expand-icon {
        cursor: pointer;
        transform: rotate(180deg);
        padding: 8px;
        border-radius: 50%;
        transition: all 0.2s ease;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        background-color: white;

        &:hover {
            background-color: rgba(211, 84, 0, 0.1);
            transform: rotate(180deg) scale(1.1);
            box-shadow: 0 3px 8px rgba(211, 84, 0, 0.2);
        }

        &:focus {
            outline: 2px solid rgba(211, 84, 0, 0.4);
            outline-offset: 2px;
        }

        &:active {
            transform: rotate(180deg) scale(0.95);
        }
    }

    .zslic_logo {
        margin-left: 0;
        transition: margin-left 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);

        &.expanded {
            margin-left: 3em;
        }
    }

    .user-actions {
        display: flex;
        align-items: center;
        gap: 10px;

        .language-trigger {
            background-color: white;
            border: 1px solid #ddd;
            border-radius: 8px;
            padding: 8px 12px;
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            transition: all 0.2s ease;

            &:hover {
                background-color: #f5f5f5;
                border-color: #D35400;
            }

            .flag {
                width: 20px;
                height: 15px;
                object-fit: cover;
                border-radius: 2px;
                position: relative;
                top:2px;
            }

            .chevron-icon {
                width: 12px;
                height: 12px;
                opacity: 0.6;
            }
        }

        .language-menu {
            min-width: 150px;

            .lang-item {
                display: flex;
                align-items: center;
                gap: 8px;
                font-size: 14px;
                font-weight: 500;
                padding: 8px 16px;

                .flag {
                    width: 20px;
                    height: 15px;
                    object-fit: cover;
                    border-radius: 2px;
                    position: relative;
                    top:0px;
                }

                &:hover {
                    background-color: #f5f5f5;
                }
            }
        }
    }
}

.profile-dialog-loading {
    min-height: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.profile-dialog-loading-text {
    color: #64748b;
    font-weight: 600;
}

:deep(.profile-dialog-tabs) {
    width: 100%;
}

:deep(.profile-dialog-tabs .zs-tab-content) {
    width: 100%;
    box-sizing: border-box;
}

:deep(.profile-dialog-tabs .zs-tab-content.active) {
    width: 100%;
}
</style>
